<app-lms-modal-frame [title]="dlgTitle" [pageHeadWidth]="420">
  <div modal-body>
    <div class="container-fluid center-screen">
      <div *ngIf="(isFingerProcessing$ | async) === true">
        <div class="loading-spinner mb-1">
          <svg class="lds-gear-set img" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <g transform="translate(50 50)">
              <g transform="translate(-17 -17) scale(0.5)">
                <g transform="rotate(150.143)">
                  <animateTransform attributeName="transform" type="rotate" values="0;360" keyTimes="0;1" dur="1.4s"
                    begin="0s" repeatCount="indefinite"></animateTransform>
                  <path
                    d="M37.3496987939662 -7 L47.3496987939662 -7 L47.3496987939662 7 L37.3496987939662 7 A38 38 0 0 1 31.359972760794346 21.46047782418268 L31.359972760794346 21.46047782418268 L38.431040572659825 28.531545636048154 L28.531545636048154 38.431040572659825 L21.46047782418268 31.359972760794346 A38 38 0 0 1 7.0000000000000036 37.3496987939662 L7.0000000000000036 37.3496987939662 L7.000000000000004 47.3496987939662 L-6.999999999999999 47.3496987939662 L-7 37.3496987939662 A38 38 0 0 1 -21.46047782418268 31.35997276079435 L-21.46047782418268 31.35997276079435 L-28.531545636048154 38.431040572659825 L-38.43104057265982 28.531545636048158 L-31.359972760794346 21.460477824182682 A38 38 0 0 1 -37.3496987939662 7.000000000000007 L-37.3496987939662 7.000000000000007 L-47.3496987939662 7.000000000000008 L-47.3496987939662 -6.9999999999999964 L-37.3496987939662 -6.999999999999997 A38 38 0 0 1 -31.35997276079435 -21.460477824182675 L-31.35997276079435 -21.460477824182675 L-38.431040572659825 -28.531545636048147 L-28.53154563604818 -38.4310405726598 L-21.4604778241827 -31.35997276079433 A38 38 0 0 1 -6.999999999999992 -37.3496987939662 L-6.999999999999992 -37.3496987939662 L-6.999999999999994 -47.3496987939662 L6.999999999999977 -47.3496987939662 L6.999999999999979 -37.3496987939662 A38 38 0 0 1 21.460477824182686 -31.359972760794342 L21.460477824182686 -31.359972760794342 L28.531545636048158 -38.43104057265982 L38.4310405726598 -28.53154563604818 L31.35997276079433 -21.4604778241827 A38 38 0 0 1 37.3496987939662 -6.999999999999995 M0 -23A23 23 0 1 0 0 23 A23 23 0 1 0 0 -23"
                    fill="#a69159"></path>
                </g>
              </g>
              <g transform="translate(0 22) scale(0.4)">
                <g transform="rotate(187.357)">
                  <animateTransform attributeName="transform" type="rotate" values="360;0" keyTimes="0;1" dur="1.4s"
                    begin="-0.0875s" repeatCount="indefinite"></animateTransform>
                  <path
                    d="M37.3496987939662 -7 L47.3496987939662 -7 L47.3496987939662 7 L37.3496987939662 7 A38 38 0 0 1 31.359972760794346 21.46047782418268 L31.359972760794346 21.46047782418268 L38.431040572659825 28.531545636048154 L28.531545636048154 38.431040572659825 L21.46047782418268 31.359972760794346 A38 38 0 0 1 7.0000000000000036 37.3496987939662 L7.0000000000000036 37.3496987939662 L7.000000000000004 47.3496987939662 L-6.999999999999999 47.3496987939662 L-7 37.3496987939662 A38 38 0 0 1 -21.46047782418268 31.35997276079435 L-21.46047782418268 31.35997276079435 L-28.531545636048154 38.431040572659825 L-38.43104057265982 28.531545636048158 L-31.359972760794346 21.460477824182682 A38 38 0 0 1 -37.3496987939662 7.000000000000007 L-37.3496987939662 7.000000000000007 L-47.3496987939662 7.000000000000008 L-47.3496987939662 -6.9999999999999964 L-37.3496987939662 -6.999999999999997 A38 38 0 0 1 -31.35997276079435 -21.460477824182675 L-31.35997276079435 -21.460477824182675 L-38.431040572659825 -28.531545636048147 L-28.53154563604818 -38.4310405726598 L-21.4604778241827 -31.35997276079433 A38 38 0 0 1 -6.999999999999992 -37.3496987939662 L-6.999999999999992 -37.3496987939662 L-6.999999999999994 -47.3496987939662 L6.999999999999977 -47.3496987939662 L6.999999999999979 -37.3496987939662 A38 38 0 0 1 21.460477824182686 -31.359972760794342 L21.460477824182686 -31.359972760794342 L28.531545636048158 -38.43104057265982 L38.4310405726598 -28.53154563604818 L31.35997276079433 -21.4604778241827 A38 38 0 0 1 37.3496987939662 -6.999999999999995 M0 -23A23 23 0 1 0 0 23 A23 23 0 1 0 0 -23"
                    fill="#293439"></path>
                </g>
              </g>
              <g transform="translate(28 4) scale(0.3)">
                <g transform="rotate(172.643)">
                  <animateTransform attributeName="transform" type="rotate" values="0;360" keyTimes="0;1" dur="1.4s"
                    begin="-0.0875s" repeatCount="indefinite"></animateTransform>
                  <path
                    d="M37.3496987939662 -7 L47.3496987939662 -7 L47.3496987939662 7 L37.3496987939662 7 A38 38 0 0 1 31.359972760794346 21.46047782418268 L31.359972760794346 21.46047782418268 L38.431040572659825 28.531545636048154 L28.531545636048154 38.431040572659825 L21.46047782418268 31.359972760794346 A38 38 0 0 1 7.0000000000000036 37.3496987939662 L7.0000000000000036 37.3496987939662 L7.000000000000004 47.3496987939662 L-6.999999999999999 47.3496987939662 L-7 37.3496987939662 A38 38 0 0 1 -21.46047782418268 31.35997276079435 L-21.46047782418268 31.35997276079435 L-28.531545636048154 38.431040572659825 L-38.43104057265982 28.531545636048158 L-31.359972760794346 21.460477824182682 A38 38 0 0 1 -37.3496987939662 7.000000000000007 L-37.3496987939662 7.000000000000007 L-47.3496987939662 7.000000000000008 L-47.3496987939662 -6.9999999999999964 L-37.3496987939662 -6.999999999999997 A38 38 0 0 1 -31.35997276079435 -21.460477824182675 L-31.35997276079435 -21.460477824182675 L-38.431040572659825 -28.531545636048147 L-28.53154563604818 -38.4310405726598 L-21.4604778241827 -31.35997276079433 A38 38 0 0 1 -6.999999999999992 -37.3496987939662 L-6.999999999999992 -37.3496987939662 L-6.999999999999994 -47.3496987939662 L6.999999999999977 -47.3496987939662 L6.999999999999979 -37.3496987939662 A38 38 0 0 1 21.460477824182686 -31.359972760794342 L21.460477824182686 -31.359972760794342 L28.531545636048158 -38.43104057265982 L38.4310405726598 -28.53154563604818 L31.35997276079433 -21.4604778241827 A38 38 0 0 1 37.3496987939662 -6.999999999999995 M0 -23A23 23 0 1 0 0 23 A23 23 0 1 0 0 -23"
                    fill="#c84445"></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div id="content-capture" [style.display]="
          showStatus &&
          (!lmsbioCapture.clientVerified ||
            !lmsbioCapture.userVerified ||
            !lmsbioCapture.faisRepVerified)
            ? 'block'
            : 'none'
        ">
        <div id="scores" class="scores py-1">
          <span>
            <h6>Scan Quality</h6>
            <input class="form-control fs-5 text-center" type="text" id="qualityInputBox" readonly
              [ngModel]="lmsbioCapture.readQuality | async" style="background-color: #dcdcdc" />
          </span>
        </div>
        <div id="status"></div>
        <!-- <div id="imagediv"></div> -->

        <div class="my-2">
          <div *ngFor="
              let data of lmsbioCapture.sampleData | async;
              let sampleDataIndex = index
            " class="mx-2">
            <label class="mt-1" [for]="'sampleData' + sampleDataIndex">Finger Data {{ sampleDataIndex + 1 }}
            </label>
            <label sampleDataIndex>: Captured success</label>
          </div>
        </div>
      </div>

      <mdb-tabs #biotabs [pills]="true" [fill]="true">
        <!-- CLIENT CAPTURE -->
        <mdb-tab *ngIf="biometricType == 'client' || biometricType == 'client-offer'" [title]="
            biometricType == 'client-offer'
              ? 'Client Verify'
              : 'Client Capture'
          ">
          <ng-template mdbTabContent>
            <div class="card">
              <div class="card-body px-1">
                <table class="table table-striped table-auto table-sm my-1">
                  <tbody>
                    <tr *ngFor="
                        let totFingers of clientEnrolled;
                        let totalFingersEnrolled = index
                      ">
                      <td class="fw-semibold w-50">Enrolled Finger</td>
                      <td>{{ totFingers?.fingerName }}</td>
                      <td>
                        <button class="btn btn-sm btn-outline-success" [style.display]="
                            lmsbioCapture.clientVerified === true
                              ? 'none'
                              : 'block'
                          " (click)="doClientFingerVerify(totFingers)">
                          Verify
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="
                        biometricType == 'client-offer' &&
                        clientEnrolled.length == 0
                      ">
                      <i>** No Fingers **</i>
                    </tr>
                    <tr *ngIf="
                        (lmsbioCapture.canDoEnroll && !noBiometrics) ||
                        this.clientEnrolled.length == 0
                      ">
                      <td class="fw-semibold w-50">Add Finger</td>
                      <td colspan="2">
                        <div *ngIf="lmsbioCapture.canDoEnroll">
                          <span class="input-group-sm align-items-center center-section">
                            <mdb-select #allFingersSelect
                              aria-role="listbox" [autoSelect]="false"
                            [formControl]="selectedFingerNameControl" class="form-control-sm select table-control"
                              (change)="onfingerChange($event.target)" required aria-label="Enroll Client">
                              <mdb-option  *ngFor="let allFingers of lstAllFingers" [value]="allFingers.value">
                              {{allFingers.description}}
                            </mdb-option>
                            </mdb-select>
                            <button class="btn btn-sm btn-primary" type="button" id="button-enroll-cl"
                              [disabled]="!canEnrollData" (click)="enrollClient()">
                              Enroll Finger
                            </button>
                          </span>
                          <div *ngIf="!lmsbioCapture.isValidFingerSelected">
                            <small class="text-danger">
                              Please select a valid option.
                            </small>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div id="content-capture" [style.display]="
                    biometricType == 'client' && skipBiometrics
                      ? 'block'
                      : 'none'
                  ">
                  <div class="my-1">
                    <table w350 class="table table-striped table-auto table-sm w-50">
                      <tbody class="field-4column-label">
                        <tr>
                          <td>Branch Manager Username:</td>
                          <td>
                            <div class="center-section">
                              <input class="form-control form-control-sm" placeholder="BM Username" [(ngModel)]="biometricsModel.bmUserName" required />
                              <button class="btn btn-sm btn-primary" type="submit" (click)="verifyBranchManager()">
                                Verify Biometrics
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Verify Finger Response:</td>
                          <td>
                            {{
                            enrollmentError == "FAILURE"
                            ? enrollmentMessage
                            : enrollmentError
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <!-- <ng-container *mdbTabPortalOutlet="ScoresCapture, context: {$implicit: biometricType}"></ng-container> -->
        </mdb-tab>

        <!-- CLIENT DISABLE -->
        <mdb-tab *ngIf="biometricType == 'client' && isUserBranchManager && showDisabledTab"
          title="Disable Client Fingers">
          <ng-template mdbTabContent title="Disable Client Fingers">
            <div class="row center-screen px-3"
              *ngIf="biometricType == 'client' && isUserBranchManager && showDisabledTab">
              <table class="table table-borderless table-striped table-auto shadow-2-strong table-sm">
                <tbody class="field-4column-label">
                  <div *ngFor="let enroll of clientEnrolled; let i = index">
                    <tr>
                      <td>Finger Id</td>
                      <td>{{ enroll.id }}</td>
                    </tr>
                    <tr>
                      <td>Finger Name</td>
                      <td>{{ enroll?.fingerName }}</td>
                    </tr>
                    <tr class="border-bottom">
                      <td></td>
                      <td>
                        <!--   *ngIf="enrollmentError !== 'SUCCESS' && enrollmentError !== 'FAILURE'" -->
                        <button class="btn btn-sm btn-outline-primary readerDivButtons" mdbRipple
                          (click)="disableClientFinger(enroll.id)">
                          Disable Finger
                        </button>
                        <div *ngIf="
                            enrollmentError === 'SUCCESS' &&
                            enrollmentMessage === 'Finger Disabled' &&
                            biometricsModel.id === enroll.id
                          " [ngClass]="'error'" style="color: green">
                          Finger Disabled.
                        </div>
                        <div *ngIf="
                            enrollmentError === 'FAILURE' &&
                            enrollmentMessage !== 'Finger Disabled' &&
                            biometricsModel.id === enroll.id
                          " [ngClass]="'error'" style="
                            color: red;
                            float: right;
                            margin-right: 303px;
                          ">
                          Finger NOT Disabled.
                        </div>
                      </td>
                    </tr>
                  </div>
                </tbody>
              </table>
            </div>
            <div class="readerDivButtons flex-container">
              <button type="button" class="btn btn-primary" (click)="disableAllClientFingers()">
                Disable All Fingers
              </button>
            </div>
          </ng-template>
        </mdb-tab>

        <!-- USER CAPTURE -->
        <mdb-tab *ngIf="biometricType == 'user' || biometricType == 'client-offer'" [title]="
            biometricType == 'client-offer' ? 'User Verify' : 'User Capture'
          ">
          <ng-template mdbTabContent>
            <div class="card">
              <div class="card-body px-1">
                <lms-table-wrapper class="center-screen mt-1 mb-2" [config]="config">
                  <table class="table table-striped table-auto table-sm my-1">
                    <tbody>
                      <tr *ngFor="
                          let totFingers of userEnrolled | paginate: config;
                          let totalFingersEnrolled = index
                        ">
                        <td class="fw-semibold">Enrolled Finger</td>
                        <td>{{totFingers?.fingerName}}</td>
                          <td><button class="btn btn-sm btn-outline-success"
                            [style.display]="lmsbioCapture.userVerified === true ?'none':'block'"
                            (click)="doUserFingerVerify(totFingers)"> Verify </button>
                        </td>
                      </tr>
                      <tr *ngIf="
                          biometricType == 'user' && lmsbioCapture.canDoEnroll
                        ">
                        <td class="fw-semibold w-50">Add Finger</td>
                        <td colspan="2">
                          <div *ngIf="biometricType == 'user' && lmsbioCapture.canDoEnroll">
                            <div class="input-group-sm user-add-wrap">
                              <mdb-select #allFingersSelect
                              aria-role="listbox" [autoSelect]="false"
                              [formControl]="selectedFingerNameControl" class="form-control-sm select table-control"
                                (change)="onfingerChange($event.target)" required aria-label="Enroll Client">
                              <mdb-option  *ngFor="let allFingers of lstAllFingers" [value]="allFingers.value">
                                {{allFingers.description}}
                              </mdb-option>
                              </mdb-select>
                              <div *ngIf="!lmsbioCapture.isValidFingerSelected">
                              <small class="text-danger">
                                Please select a valid option.
                              </small>
                            </div>
                              <button class="btn btn-sm btn-primary" type="button" id="button-enroll-cl"
                                [disabled]="!canEnrollData" (click)="enrollUser()">
                                Enroll Finger
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </lms-table-wrapper>
              </div>
            </div>
          </ng-template>
        </mdb-tab>

        <!-- REP USER CAPTURE -->
        <mdb-tab
          *ngIf="((biometricType == 'user' || biometricType=='client-offer') && (biometricsInfo.FaisRepRequired === true) )"
          [title]="biometricType=='client-offer' ? 'FAIS Rep Verify': 'FAIS Rep Capture'">
          <ng-template mdbTabContent>
            <mdb-select [(ngModel)]="selectedUser" (ngModelChange)="filterFingerprints()"
              class="form-control-sm select table-control my-1 w-75">
              <mdb-option value="">--- Select Representative ---</mdb-option>
              <mdb-option value="flag">AUL Call Centre Approval</mdb-option>
              <mdb-option *ngFor="let faisRepSelection of uniqueUsernames" [value]="faisRepSelection">
                {{ faisRepSelection }}
              </mdb-option>
            </mdb-select>
            <lms-table-wrapper class="center-screen mt-1" [config]="config2">
              <table *ngIf="repFingerId === 0" class="table table-striped table-hover table-sm my-1 mx-2">
              <tbody>
                <button *ngIf="selectedUser === 'flag'" class="btn btn-sm btn-outline-success"
                  (click)="flagForCallCentreApproval()">
                  Flag for Call Centre Approval
                </button>
                <tr *ngFor="let finger of filteredFingers | paginate: config2;let totalFingersEnrolled = index">
                  <td class="fw-semibold">Enrolled Finger</td>
                  <td>
                    {{ finger?.fingerName }}
                  </td>
                  <td><button class="btn btn-sm btn-outline-success"
                      [style.display]="lmsbioCapture.faisRepVerified ? 'none':'block'"
                      (click)="doRepUserFingerVerify(finger)">Verify</button></td>
                </tr>
              </tbody>
            </table>
            </lms-table-wrapper>
            <!-- <lms-table-wrapper class="center-screen mt-0" [config]="config2">
              <table class="table table-striped table-hover table-sm my-1 mx-2">
                <tbody>
                  <tr *ngFor="let finger of filteredFingers | paginate: config2; let totalFingersEnrolled = index">
                    <td></td>
                    <td>
                      {{ finger?.fingerName }}
                    </td>
                    <td><button class="btn btn-sm btn-outline-success"
                      [style.display]="lmsbioCapture.faisRepVerified ? 'none':'block'"
                      (click)="doRepUserFingerVerify(finger)">Verify</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </lms-table-wrapper> -->
          </ng-template>
        </mdb-tab>

        <!-- USER DISABLE -->
        <mdb-tab *ngIf="biometricType == 'user' && showUserDisabledTab" title="Disable User Fingers">
          <ng-template mdbTabContent title="Disable User Fingers">
            <div class="row center-screen px-4" *ngIf="showUserDisabledTab">
              <lms-table-wrapper class="center-screen my-2" [config]="config">
                <table class="table table-borderless table-striped table-auto shadow-2-strong table-sm">
                  <tbody class="field-4column-label">
                    <div *ngFor="
                        let enroll of userEnrolled | paginate: config;
                        let i = index
                      ">
                      <tr>
                        <td>Finger Id</td>
                        <td>{{ enroll.id }}</td>
                      </tr>
                      <tr>
                        <td>Finger Name</td>
                        <td>{{ enroll?.fingerName }}</td>
                      </tr>
                      <tr class="border-bottom">
                        <td></td>
                        <td>
                          <button class="btn btn-sm btn-outline-primary readerDivButtons" mdbRipple
                            (click)="disableUserFinger(enroll.id)">
                            Disable Finger
                          </button>
                          <div *ngIf="
                              enrollmentError === 'SUCCESS' &&
                              enrollmentMessage === 'Finger Disabled' &&
                              biometricsModel.id === enroll.id
                            " style="color: green">
                            Finger Disabled.
                          </div>
                          <div *ngIf="
                              enrollmentError === 'FAILURE' &&
                              enrollmentMessage !== 'Finger Disabled' &&
                              biometricsModel.id === enroll.id
                            " [ngClass]="'error'" style="
                              color: red;
                              float: right;
                              margin-right: 303px;
                            ">
                            Finger NOT Disabled.
                          </div>
                        </td>
                      </tr>
                    </div>
                  </tbody>
                </table>
              </lms-table-wrapper>
            </div>

            <div class="flex-container">
              <button [disabled]="getUserFingersCount()" class="btn btn-sm btn-primary" type="button"
                (click)="close()">
                Close
              </button>
              <button type="button" class="btn btn-sm btn-primary" (click)="disableAllUserFingers()">
                Disable All Fingers
              </button>
            </div>
          </ng-template>
        </mdb-tab>
      </mdb-tabs>
      <ng-container *ngIf="(signatureOpen$ | async) === true">
        <div class="col-11 align-items-stretch justify-content-center my-1">
          <table class="table table-striped table-sm m-2 shadow-2-strong rounded-1">
            <caption>
              Signature Verification
            </caption>
            <tbody>
              <tr>
                <td>Client Signature -</td>
                <td>{{ verifiedFingers[0]?.fingerName }}</td>
              </tr>
              <tr>
                <td>Consultant Signature -</td>
                <td>{{ verifiedFingers[1]?.fingerName }}</td>
              </tr>
              <tr *ngIf="verifiedRepFingers.length > 0 && (biometricsInfo.FaisRepRequired === true)">
                <td>FAIS Rep Signature -</td>
                <td>{{ verifiedRepFingers[0]?.fingerName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
  </div>
  <div modal-actions class="lms-action-bar">
    <button class="btn btn-primary" type="button" (click)="modalRef.close()">Close</button>
    <button class="btn btn-primary" type="button" [style.display]="biometricType == 'client-offer' ? 'none' : 'block'"
      [disabled]="!canStartScan" (click)="startCapture(false, true); showStatus = true">
      Start Scan
    </button>

    <button [style.display]="
        biometricType == 'client' && skipBiometrics ? 'block' : 'none'
      " [disabled]="!canContinueApp" class="btn btn-primary" (click)="continueApplication()">
      Continue Application
    </button>

    <button [style.display]="(signatureOpen$ | async) === true ? 'block' : 'none'" class="btn btn-sm btn-primary"
      type="button" (click)="signDocument()">
      Sign Document
    </button>

    <button [style.display]="enableSkip ? 'block' : 'none'" class="btn btn-primary" (click)="continueLoan()">
      Skip Biometrics
    </button>
  </div>
</app-lms-modal-frame>
